import React from "react";
import {Navigate, Route, Routes, useLocation, useParams, useSearchParams} from "react-router-dom";
import {useAuth} from "../../context";
import {ActivateDevice} from "./ActivateDevice";
import {useGetJson} from "../../hooks";
import {DeviceList} from "./DeviceList";
import {DeviceHome} from "./DeviceHome";
import {endpoints} from "../../utils2";
import {Alert, Container} from "react-bootstrap";

export function RoutesDevice() {

    const {uid} = useParams()

    return <>
        {/*<Nav variant="underline"  justify={justify}>*/}
        {/*    <ResponsiveNavTab to={`${path}/activate`} icon={<IconTab name="power"/>} title="Activation"/>*/}
        {/*    <ResponsiveNavTab to={`${path}/input`} icon={<IconTab name="box-arrow-in-down"/>} title="Input"/>*/}
        {/*    <ResponsiveNavTab to={`${path}/hybrid`} icon={<IconTab name="repeat"/>} title="Hybrid"/>*/}
        {/*    <ResponsiveNavTab to={`${path}/output`} icon={<IconTab name="box-arrow-up"/>} title="Output"/>*/}
        {/*</Nav>*/}

        <Container fluid="lg">
            <Routes>
                {/* Search a device and redirect */}
                <Route path="query" element={<PrivatePath><QueryDeviceAndRedirect/></PrivatePath>}/>

                {/* Activate (PrivatePath transforms "self" in the proper userId) */}
                <Route path="activate" element={<PrivatePath><ActivateDevice/></PrivatePath>}/>

                <Route path="*" element={<PrivatePath><DeviceList/></PrivatePath>}/>
            </Routes>
        </Container>
    </>
}

function QueryDeviceAndRedirect() {
    const {authToken} = useAuth()
    const {uid} = useParams()
    const [searchParams, setSearchParams] = useSearchParams()
    const serial = searchParams.get("serial")

    const [getData, loadingData, errorData, clearErrorData] = useGetJson(endpoints.device.query(serial), authToken?.jwt)
    const device = getData?.data

    if (device == null)
        return <Alert variant="danger" show={errorData} dismissible onClose={clearErrorData}>{errorData}</Alert>

    return <Navigate to={`/device/${uid}/${device.id}/dash`}/>
}

function PrivatePath({children}) {
    const {loggedIn, userId, admin} = useAuth()
    const {uid} = useParams()
    const location = useLocation()

    if (!loggedIn)
        return <Navigate to="/account/login" state={{from: location}} replace={true}/>

    if (uid === "self")
        return <Navigate to={{pathname: location.pathname.replace("self", userId), search: location.search}}/>

    if (!admin && userId !== uid)
        return <Navigate to={`/device/${userId}`}/>

    return children
}


